import { render } from "./AttrLink.vue?vue&type=template&id=1c475f22"
import script from "./AttrLink.vue?vue&type=script&lang=js"
export * from "./AttrLink.vue?vue&type=script&lang=js"

import "./AttrLink.vue?vue&type=style&index=0&id=1c475f22&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/widgets/components_core/AttrLink.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1c475f22"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1c475f22', __exports__)) {
    api.reload('1c475f22', __exports__)
  }
  
  module.hot.accept("./AttrLink.vue?vue&type=template&id=1c475f22", () => {
    api.rerender('1c475f22', render)
  })

}


export default __exports__